<div class="mpp-star-rating__content">
  <div class="mpp-star-rating__item" *ngFor="let starFlag of getStarsRating()">
    <img alt="" class="mpp-star-rating__img" [src]="getImgPath(starFlag)" />
  </div>
</div>
